import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';

import { AuthService } from '../services/auth.service';

/**
 * Guard that checks if the user is logged in.
 * Redirects to the app's own login page if not authenticated.
 */
export const authGuard: CanActivateFn = () => {
  const router = inject(Router);
  const authService = inject(AuthService);

  return authService.isLoggedIn().pipe(map(isLoggedIn => (isLoggedIn ? true : router.createUrlTree(['/auth/login']))));
};
